import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const Inv1110SearchParamsSchema = z
  .object({
    number: z.string().optional(),
    partyId: z.string().optional(),
    refNo: z.string().optional(),
    dateFrom: z.coerce.date().optional(),
    dateTo: z.coerce.date().optional(),
    status: z.string().optional(),
    filterStatus: z.string().optional(),
    lotNo: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv1110SearchParams = z.infer<typeof Inv1110SearchParamsSchema>

export const Inv1110SearchResultModelSchema = z.object({
  id: z.number(),
  number: z.string(),
  partyId: z.number().nullable(),
  refNo: z.string().nullable().optional(),
  remark: z.string().nullable().optional(),
  date: z.coerce.date(),
  status: z.number(),
  isFulfilled: z.boolean().nullable(),
})

export type Inv1110SearchResultModel = z.infer<
  typeof Inv1110SearchResultModelSchema
>

export const Inv1110SearchResultSchema = z
  .object({
    data: z.array(Inv1110SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Inv1110SearchResult = z.infer<typeof Inv1110SearchResultSchema>
